import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ProfessionShape } from 'client/constants/tax/shapes';
import { saveProfessions } from 'client/actions/tax/professions';
import { fetchCategories, fetchStaticCategoriesIfNeeded } from 'client/actions/tax/expenses';

const mapStateToProps = state => ({
  professions: state.professions.content,
  selectedProfessionIds: state.professions.selected,
  user: state.user,
});

const propTypes = {
  fetchCategories: PropTypes.func.isRequired,
  saveProfessions: PropTypes.func.isRequired,
  fetchStaticCategoriesIfNeeded: PropTypes.func.isRequired,
  selectedProfessionIds: PropTypes.array,
  user: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  professions: PropTypes.arrayOf(ProfessionShape).isRequired,
};

const defaultProps = {
  selectedProfessionIds: [],
};

class LookupAnimationPage extends React.Component {
  getSelectedProfessions = () =>
    this.props.professions.filter(p => this.props.selectedProfessionIds.indexOf(p.id) > -1);

  getSelectedParams() {
    return this.getSelectedProfessions().map(p => p.seoSlug);
  }

  getReportUrl() {
    return `/deductions/${this.getSelectedParams().join('/')}`;
  }

  // Fetches categories and saves professions on animation transition, otherwise
  // relies on Report static method fetchData from account creation redirect
  handleRedirect = () => {
    if (this.props.user && this.props.user.isLoggedIn) {
      this.props.fetchCategories(this.props.selectedProfessionIds);
      this.props.fetchStaticCategoriesIfNeeded();
      this.props.saveProfessions(this.props.selectedProfessionIds);
      // 4.5 seconds is an arbitrary delay based on gif animation length
      setTimeout(() => this.props.router.replace(this.getReportUrl()), 4500);
    } else {
      setTimeout(() => {
        window.location.replace(`/account/create?&redirect=/tax${this.getReportUrl()}?s`);
      }, 4500);
    }
  };

  render() {
    return (
      <div className="center-col pad-bottom-2">
        <div className="animation-transition-div">
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <img
              onLoad={this.handleRedirect}
              alt="deduction-guide-lookup-animation"
              src="https://images.contentful.com/heg7gyzix6dq/2lgB9bLQ9yKm48SW26kuu6/2b793d638275e51c3b555e887d641412/deduction-guide-lookup-animation.gif" />
          </div>
          <div className="text-center" style={{ padding: '3rem 1rem 1rem' }} />
        </div>
      </div>
    );
  }
}

LookupAnimationPage.propTypes = propTypes;
LookupAnimationPage.defaultProps = defaultProps;

export default connect(mapStateToProps, {
  fetchCategories,
  fetchStaticCategoriesIfNeeded,
  saveProfessions,
})(LookupAnimationPage);
